export default "__VITE_ASSET__9cfe91a5__"